import { AxiosError } from "axios";

export type FieldErrors = Record<string, string[]>;

export class ValidationError extends Error {
  readonly fields: FieldErrors;

  constructor(axiosError: AxiosError) {
    super("Validation failed");
    this.name = "ValidationError";
    const data = axiosError.response?.data as { errors?: FieldErrors } | undefined;
    this.fields = data?.errors ?? {};
  }

  static isShape(axiosError: AxiosError): boolean {
    const data = axiosError.response?.data as { errors?: FieldErrors } | undefined;
    return Boolean(data?.errors);
  }
}
